export { default } from './SegurosConteudos';
